import { Experiment } from '@amplitude/experiment-js-client';

import type { InitializeExperimentClient } from './initializeExperimentClient.types';

/**
 * Experiment client factory for the CLIENT build (browser).
 *
 * Selected by resolution, not by an import-site branch: the client build prefers `.web.ts` over the
 * sibling `.ts` (config/webpack/resolvers.ts → `extensions`), and the server build omits `.web.*`
 * (config/webpack/server.ts → `extensions`) so it never reaches this file. Jest matches the client
 * build via `moduleFileExtensions` in jest.config.js, because its environment is jsdom.
 *
 * This module must have NO import path — static or transitive — to `@amplitude/experiment-node-server`.
 * That is the entire point: the browser SDK is the only Amplitude runtime the client graph should be
 * able to reach (PRNT-4899). `initializeExperimentClient.spec.ts` asserts it, and
 * `test/build-contracts/amplitudeRuntimeSplit.contract.spec.ts` proves it against real bundles.
 *
 * Delegates on CALL, deliberately — it does not capture `Experiment.initialize` at module load. The
 * code this replaced read the property inside the SDK memo, so capturing eagerly here would move
 * that read to import time, changing behavior for anything that patches or wraps
 * `Experiment.initialize` after module evaluation (test mocks being the case that caught it: an
 * eager read fires before the mock's backing binding exists).
 */
export const initializeExperimentClient: InitializeExperimentClient = (apiKey, initConfig) => Experiment.initialize(apiKey, initConfig);
